import { SvgIcon, SvgIconProps } from '@mui/material'

export const VISA = ({ viewBox = '0 0 141.73 141.73', ...props }: SvgIconProps) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M62.94 89.57H53.2l6.08-37.38h9.74zM45 52.2L35.74 77.9l-1.1-5.54-3.28-16.8s-.4-3.37-4.61-3.37H11.4l-.18.63s4.69.98 10.18 4.27l8.45 32.48H40L55.5 52.2H45zm76.56 37.38h8.94l-7.8-37.38h-7.82c-3.61 0-4.5 2.78-4.5 2.78l-14.5 34.6h10.14l2.03-5.55h12.37l1.14 5.55zm-10.71-13.22l5.11-14 2.88 14h-8zM96.64 61.18l1.4-8.03s-4.3-1.63-8.76-1.63c-4.83 0-16.3 2.11-16.3 12.37 0 9.66 13.46 9.78 13.46 14.86s-12.08 4.16-16.06.96l-1.45 8.4s4.35 2.1 10.99 2.1c6.64 0 16.66-3.43 16.66-12.8C96.58 67.7 83 66.8 83 62.58c0-4.23 9.48-3.69 13.64-1.4z"
      fill="#2566af"
    />
    <path
      d="M34.64 72.36l-3.28-16.8s-.4-3.37-4.61-3.37H11.4l-.18.63s7.37 1.53 14.44 7.25a29.15 29.15 0 018.97 12.3z"
      fill="#e6a540"
    />
    <path fill="none" d="M0 0h141.73v141.73H0z" />
  </SvgIcon>
)
